(function($){
  $(function() {
    var $footerWithForm = $('.footer-with-form');

    if($footerWithForm.length) {
      var footerWithForm = (function() {
        var $tab = $footerWithForm.find('.tab-link');
        var $tabPanel = $footerWithForm.find('.tab-pane');

        function handleTabs(e) {
          e.preventDefault();
          var targetTab = $(this).attr('data-pane-target');

          $tab.removeClass('active');
          $tabPanel.removeClass('show')
          $(this).addClass('active');
          $(targetTab).addClass('show');
        }
        
        return {
          init: function() {
            this.bindEvents();
          },
          bindEvents: function() {
            $tab.on('click', handleTabs);
          }
        }
      })();

      footerWithForm.init();
    } 
  });
})(jQuery);